import { categoryIndex } from '@/mocks/home';
import SectionHeading from '@/components/base/SectionHeading';

export default function CategoryIndex() {
  return (
    <section id="categories" className="w-full scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <SectionHeading
          eyebrow="全量分类"
          title="分类索引速览"
          desc="把全站的分类维度集中在一排入口里，点选即可跳转到对应汇总区块，减少反复查找的步骤。"
        />

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {categoryIndex.map((item) => (
            <a
              key={item.name}
              href="#summary"
              className="group flex cursor-pointer items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-4 transition-colors hover:border-primary-300"
            >
              <span className="flex min-w-0 items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-primary-600 transition-colors group-hover:bg-primary-100">
                  <i className={`${item.icon} text-lg`} />
                </span>
                <span className="min-w-0">
                  <span className="block truncate font-label text-sm text-foreground-900">
                    {item.name}
                  </span>
                  <span className="block font-label text-[11px] text-foreground-500">
                    {item.count} 条
                  </span>
                </span>
              </span>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-300 transition-colors group-hover:text-primary-600">
                <i className="ri-arrow-right-s-line text-lg" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}